/**
 * Adzuki. My Settings - Invoice Notes list actions
 *
 * SET-52, decision B3: the two mutating actions on this list are POSTs.
 *
 * THEY WERE GET LINKS. "Make default" was a plain href on an empty-circle icon and delete was a
 * link with a client-side confirm in front of it. Both now post to their own endpoint, and the
 * panel is re-rendered from the server afterwards - so what the advisor sees is what was stored
 * rather than what this file assumed.
 *
 * THE MACHINERY IS SHARED (SET-133). The ajax, the three answers a list endpoint can give and the
 * delegated binding live in my_settings_list_actions.js, with Shipping, Credit Cards and Franchise
 * Documents. What is left here is this panel's own facts: what to bind, where to post, and what to
 * say if the request never completes.
 *
 * THE DEFAULT RADIO IS PER LOCATION, and the selector below does not have to care. The markup puts
 * Top and Bottom in separate radio groups, so the browser keeps them independent and each change
 * posts one note id; the endpoint scopes the demotion by location. One selector, two groups.
 *
 * ONE RELOAD DOES BOTH COLUMNS. The shared helper re-reads the panel on every non-success answer,
 * so a refused make-default goes back to the stored value rather than leaving the radio the
 * advisor clicked selected against a record that was never written.
 *
 * NOTHING HERE WRITES ADVISOR-FACING COPY apart from the two last-resort failure strings. Success
 * and refusal text comes from the response, and the delete confirmation is raised BY THE SERVER -
 * invoiceNoteDelete() answers an unconfirmed request with a confirmation_prompt rather than
 * deleting, exactly as a form's confirm() does.
 */

(function MySettingsInvoiceNotes($, Adzuki)
{
	"use strict";

	// INSIDE ready, NOT AT LOAD, and the same in all four list panels. gulp concatenates
	// js/Adzuki/*.js by filename, so this file runs BEFORE my_settings_list_actions.js and the
	// helper is not assigned yet at that point in the bundle. Every script has executed by the time
	// a ready callback fires.
	$(document).ready(function documentReady() {
		if (!Adzuki.MySettings || !Adzuki.MySettings.ListActions) {
			return;
		}

		Adzuki.MySettings.ListActions.bind({
			url    : '/MySettings/invoiceNotes',
			actions: [
				{
					event   : 'change',
					selector: '.my-settings-invoice-note-default',
					url     : function makeDefault($control) {
						return '/MySettings/invoiceNoteDefault/' + $control.val();
					},
					failure: 'There was an error attempting to set the default invoice note.'
				},
				{
					// ITS OWN ATTRIBUTE, NOT THE BARE data-my-settings-delete. bind() delegates from the
					// whole overlay on the selector alone, with no per-panel scoping - so two panels
					// sharing a selector both fire on one click. Shipping owns the generic name because it
					// was first; Blackout, Documents and Credit Cards all took a specific one, and so does
					// this. Reusing it here would have posted every invoice-note delete to
					// /MySettings/shippingDelete as well, and the two answers would race to reload the panel.
					event   : 'click',
					selector: '[data-my-settings-note-delete]',
					url     : function remove($control) {
						return '/MySettings/invoiceNoteDelete/' + $control.attr('data-my-settings-note-delete');
					},
					failure: 'There was an error attempting to delete the invoice note.'
				}
			]
		});
	});
}(jQuery, window.Adzuki || {}));